<template>
  <a-col :xl="16" :lg="24" :md="24" :sm="24" :xs="24">
    <a-card class="antd-pro-pages-dashboard-analysis-salesCard" :style="{ height: '341px', 'margin-top': '10px' }"
      :bodyStyle="{ 'padding-top': '0px', }">
      <div slot="title">
        <div class="radius"></div>
        <div class="radiusTitle">流量历史记录</div>
      </div>
      <div slot="extra" class="extra">m³</div>
      <div class="content" style="pdding-top:0px">
        <a-empty style="margin-top:80px" v-if="!isData" />
        <div v-if="isData">
          <div :id="id" style="width: 100%;height:300px;"></div>
        </div>
      </div>
    </a-card>
  </a-col>
</template>

<script>
import { getUUID } from '@/utils/util'
export default {
  name: 'DashBorard',
  components: {},
  data () {
    return {
      isData: false,
      queryUrl: '/pipe-network/report/chart/night-traffic/history',
      loading: false,
      id: getUUID()
    }
  },
  methods: {
    getList (params) {
      this.isData = true
      this.$http.get(this.queryUrl, { params }).then(({ data }) => {
        console.log(data.data)
        data.data != null ? (this.isData = true) : (this.isData = false)
        console.log(this.isData)
        var arr = data.data[0]
        var xData = []
        var yData = []
        arr.map(item => {
          xData.push(item.label)
          yData.push(item.value)
        })
        var chartDom = document.getElementById(this.id)
        var myChart = echarts.init(chartDom)
        var option

        option = {
          xAxis: {
            type: 'category',
            data: xData
          },
          yAxis: {
            type: 'value',
            min: function (val) {
              return Math.floor(val.min)
            }
          },
          series: [
            {
              name: arr[0].zoneName,
              data: yData,
              type: 'line'
            }
          ],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          }
        }

        option && myChart.setOption(option)
      })
    }
  },
  created () {
    // this.$nextTick(() => {
    //   this.getList()
    // })
  }
}
</script>
<style lang="less" scoped>
.radius {
  float: left;
  width: 6px;
  height: 21px;
  background: #0265ff;
  border-radius: 3px;
}

.radiusTitle {
  margin-left: 10px;
  float: left;
  width: 100px;
  height: 21px;
  line-height: 21px;
  font-family: MicrosoftYaHeiSemibold;
  font-size: 16px;
  color: #101010;
  letter-spacing: 0.63px;
  font-weight: 600;
}

.radioTitle {
  height: 29px;
  font-family: MicrosoftYaHeiSemibold;
  font-size: 14px;
  color: #101010;
  letter-spacing: 0.56px;
  font-weight: 600;
}

.extra {
  height: 22px;
  opacity: 0.38;
  font-family: MicrosoftYaHei;
  font-size: 12px;
  color: #404549;
  font-weight: 400;
}

.ant-card-body {
  padding: 0;
}
</style>
